module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("新增藥物儲存"), _c('span', {
    staticClass: "icon-right",
    on: {
      "click": function($event) {
        return _vm.$emit('cancelForm')
      }
    }
  }, [_vm._v("X")])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "search-dynamic"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceId),
      expression: "deviceId"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.deviceId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.setCurrentDevice]
    }
  }, _vm._l((_vm.devices), function(device, num) {
    return _c('option', {
      domProps: {
        "value": num
      }
    }, [_vm._v(_vm._s(device.series))])
  }), 0)])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "search-dynamic"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDrug),
      expression: "searchDrug"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.searchDrug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchDrug = $event.target.value
      }
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.medicines.length !== 0),
      expression: "medicines.length !== 0"
    }],
    staticClass: "input-options-wrap"
  }, _vm._l((_vm.medicines), function(med, num) {
    return _c('div', {
      staticClass: "input-option",
      on: {
        "click": function($event) {
          return _vm.setMedicine(num)
        }
      }
    }, [_vm._v(_vm._s(med.code) + " - " + _vm._s(med.CGMH_number) + " - " + _vm._s(med.generic_name))])
  }), 0)])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-group col-6"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stock),
      expression: "stock"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.stock)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stock = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group col-6"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxStock),
      expression: "maxStock"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.maxStock)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxStock = $event.target.value
      }
    }
  })])])]), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventoried),
      expression: "inventoried"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "name": "defaultLogin",
      "value": "password"
    },
    domProps: {
      "checked": Array.isArray(_vm.inventoried) ? _vm._i(_vm.inventoried, "password") > -1 : (_vm.inventoried)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.inventoried,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "password",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.inventoried = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.inventoried = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.inventoried = $$c
        }
      }
    }
  }), _c('span', [_vm._v("盤點與否")])])]), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.formComplete === false
    },
    on: {
      "click": _vm.createDrugStorage
    }
  }, [_vm._v("新增")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("選擇位置")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("選擇藥物")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("儲存數量")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("最大存量")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f65cadc6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CreateDrugStorageForm.vue
// module id = 1554
// module chunks = 1